import Delegator from './delegates';
import IMessage, { IShared, sharedAttrs, ignoreAttrs } from './types/message.type';

const only = require('only'); // tslint:disable-line

const ignoresAttrs: string[] = ['inspect', 'toJSON', 'throw', 'onerror', 'defineGetter'].concat(ignoreAttrs).concat(sharedAttrs);

const context: any = {
    shareData: null,
    /**
     * 获取公共数据
     * @returns {IShared}
     */
    getShared(): IShared {
        if (this.shareData) {
            return this.shareData;
        } else {
            this.shareData = only(this, sharedAttrs);
            return this.shareData;
        }
    },

    /**
     * 获取自定义数据
     * @param {string[]} customAttrs
     * @returns {any}
     */
    getCustom(customAttrs: string[]) {
        return only(this, customAttrs);
    },

    /**
     * 获取运行时所需数据
     * @param {string[]} ignore
     */
    inspect(ignore: string[] = []): void {
        if (this === context) {
            return this;
        }
        return this.toJSON(ignore);
    },

    toJSON(ignore: string[]): IMessage {
        const ignores: string[] = ignoresAttrs.concat(ignore);
        const runtimes: string[] = [];
        for (const prop in this) {
            if (!this.hasOwnProperty(prop) && ignores.indexOf(prop) === -1) {
                runtimes.push(prop);
            }
        }

        return only(this, runtimes);
    },

    throw(...args: any[]) {
        throw new Error(...args);
    },

    onerror(err: any): void {
        if (null == err) {
            return;
        }
        if (!(err instanceof Error)) {
            err = new Error(`non-error thrown: ${err}`);
        }
        return;
    },

    defineGetter(key: string, value: any) {
        try {
            Object.defineProperty(this.runtime, key, {
                get: () => {
                    return value;
                },
                enumerable: true,
                configurable: true,
            });
        } catch (err) {
            console.log(err); // eslint-disable-line
        }
        new Delegator(context, 'runtime').getter(key);
    },
};

new Delegator(context, 'runtime')
    .getter('env')
    .getter('project')
    .getter('autopv')
    .getter('version')
    .getter('screen')
    .getter('userAgent')
    .getter('jsBridge')
    .getter('network')
    .getter('@timestamp')
    .getter('duration')
    .getter('localStorage')
    .access('channel')
    .access('region')
    .access('unionId')
    .access('pageId')
    .access('pageUrl');

export default context;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/core/context.ts